import { useEffect } from 'react';
import './FlyToCartOverlay.css';

export default function FlyToCartOverlay() {
  useEffect(() => {
    const handleFlyToCart = (e) => {
      const { startRect, imageUrl } = e.detail || {};

      // 1. Locate target element (Cart icon in header or mobile bar across themes)
      const targetEl =
        document.querySelector('.coffee-cart-icon-btn') ||
        document.querySelector('.coffee-cart-pill');
      if (!targetEl) return;

      const targetRect = targetEl.getBoundingClientRect();

      // 2. Calculate start position
      const startX = startRect
        ? startRect.left + startRect.width / 2 - 25
        : window.innerWidth / 2 - 25;
      const startY = startRect
        ? startRect.top + startRect.height / 2 - 25
        : window.innerHeight / 2 - 25;

      // 3. Calculate target position
      const targetX = targetRect.left + targetRect.width / 2 - 25;
      const targetY = targetRect.top + targetRect.height / 2 - 25;

      // 4. Create flying DOM element
      const flyer = document.createElement('div');
      flyer.className = 'fly-to-cart-item';
      flyer.style.left = `${startX}px`;
      flyer.style.top = `${startY}px`;

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = 'Adding product';
        flyer.appendChild(img);
      } else {
        const icon = document.createElement('span');
        icon.className = 'flyer-icon';
        icon.innerHTML = '🛒';
        flyer.appendChild(icon);
      }

      document.body.appendChild(flyer);

      // 5. Animate along a curved path using Web Animations API
      const midX = (startX + targetX) / 2 + (startX < targetX ? -40 : 40);
      const midY = Math.min(startY, targetY) - 90; // Arc peak upwards

      const animation = flyer.animate(
        [
          {
            transform: 'translate(0, 0) scale(1) rotate(0deg)',
            opacity: 1,
            boxShadow: '0 8px 24px color-mix(in srgb, var(--color-text, #000) 25%, transparent)',
          },
          {
            transform: `translate(${midX - startX}px, ${midY - startY}px) scale(0.9) rotate(-15deg)`,
            opacity: 0.95,
            boxShadow:
              '0 12px 30px color-mix(in srgb, var(--color-accent, var(--color-primary)) 40%, transparent)',
            offset: 0.45,
          },
          {
            transform: `translate(${targetX - startX}px, ${targetY - startY}px) scale(0.2) rotate(-35deg)`,
            opacity: 0.2,
            boxShadow: '0 2px 8px color-mix(in srgb, var(--color-text, #000) 10%, transparent)',
            offset: 1,
          },
        ],
        {
          duration: 700,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'forwards',
        },
      );

      animation.onfinish = () => {
        flyer.remove();

        // Trigger bounce/pulse on the target cart element
        targetEl.classList.remove('cart-icon-bounce');
        // Force reflow
        void targetEl.offsetWidth;
        targetEl.classList.add('cart-icon-bounce');

        setTimeout(() => {
          targetEl.classList.remove('cart-icon-bounce');
        }, 600);
      };
    };

    window.addEventListener('fly-to-cart', handleFlyToCart);
    return () => window.removeEventListener('fly-to-cart', handleFlyToCart);
  }, []);

  return null;
}
